import React from 'react';
import styled from 'styled-components';

const Footer: React.FC<{}> = () => {
  return (
    <div className="wrapper">
      <ListWrap>
        <List>
          <a href="http://juggling-pintcle.com/">web</a>
        </List>
        <List>
          <a href="https://twitter.com/jugglingpintcle">twitter</a>
        </List>
        <List>
          <a href="https://scrapbox.io/pintcle">scrapbox</a>
        </List>
        <List>
          <a href="https://juggling-mstdn.net/@pintcle">mastodon</a>
        </List>
      </ListWrap>
      <div style={{ textAlign: 'right', fontSize: '0.6em' }}>
        <span> © 2020 Juggling Unit ピントクル</span>
      </div>
    </div>
  );
};

const ListWrap = styled.ul`
  display: flex;
  list-style: none;
  padding: 0;
  margin: 0;
`;

const List = styled.li`
  padding-right: 20px;
`;

export default Footer;
